import { createFileRoute } from "@tanstack/react-router"
import { Homepage } from "@/content"

export const Route = createFileRoute("/$locale/")({
  component: Index,
})

function Index() {
  return <Homepage />
}
